import { createReducer, on } from "@ngrx/store";
import { BIGTransit } from "src/model/class/telegram classes/big-transit";
import { HistoryTransit } from "src/model/interface/history-transit";
import {
  historyTransitCompleteAddNewTransitInHistoryAction,
  historyTransitRemoveExistingTransitAction,
  historyTransitRemoveHistoryTransitReleatedToRemovedPlantAction,
} from "../actions/history-transit.actions";

const initialState: Array<HistoryTransit> = [];

/**
 * Reducer to handle history transit
 */
export const HistoryTransitReducer = createReducer(
  initialState,
  on(
    historyTransitCompleteAddNewTransitInHistoryAction,
    (listHistoryTransit: Array<HistoryTransit>, action) => {
      return [action.historyTransit, ...listHistoryTransit];
    }
  ),

  on(
    historyTransitRemoveExistingTransitAction,
    (listHistoryTransit: Array<HistoryTransit>, action) => {
      return listHistoryTransit.filter((historyTransit: HistoryTransit) => {
        let filter: boolean = false;

        if (
          historyTransit.idPlant === action.idPlant &&
          historyTransit.idDevice === action.idDevice
        ) {
          const expectedTransit = new BIGTransit();
          expectedTransit.code = historyTransit.code;
          expectedTransit.accessResult = historyTransit.accessResult.toString();
          expectedTransit.date = historyTransit.date;
          expectedTransit.time = historyTransit.time;
          expectedTransit.uid = historyTransit.uid;

          expectedTransit.buildTelegramByProps();

          return expectedTransit.telegram !== action.serverConfirmationTelegram;
        }

        return filter;
      });
    }
  ),
  on(
    historyTransitRemoveHistoryTransitReleatedToRemovedPlantAction,
    (listHistoryTransit: Array<HistoryTransit>, action) => {
      return listHistoryTransit.filter(
        (historyTransit: HistoryTransit) =>
          historyTransit.idPlant !== action.idPlant
      );
    }
  )
);
